
<table class="table" *ngIf="subscriptionGroup">
  <tbody>
    <tr>
      <td>Name</td>
      <td>{{subscriptionGroup.name}} </td>
    </tr>
    <tr>
      <td>Description</td>
      <td>{{subscriptionGroup.description}} </td>
    </tr>


</tbody>
</table>
<app-listing-grouping  *ngIf="subscriptionGroup"
[subscriptionGroup]="subscriptionGroup">
</app-listing-grouping>

<div class ="text-center">
  <button (click)="createNewGrouping()" class="mt-1 me-2 btn btn-primary"> Create Grouping</button>
  <a [routerLink]="['/batch/groups/index', server_user_id]" class="mt-1 btn btn-primary"> <i class="fa fa-list"></i> List</a>
</div>

